document.addEventListener("DOMContentLoaded", function () {
  const menus = document.querySelectorAll(".mega-menu__list");
  menus.forEach(menu => {
    const items = menu.querySelectorAll("li.mega-menu__column");
    if (!items.length) return;
    const firstItem = items[0];
    firstItem.classList.add("mega-menu__column--active");
    items.forEach(item => {
      const imgLink = item.querySelector(".mega-menu__collection-link img");
      const originalSrc = imgLink ? imgLink.src : null;
      item.addEventListener("mouseenter", () => {
        items.forEach(i => i.classList.remove("mega-menu__column--active"));
        item.classList.add("mega-menu__column--active");
        if (imgLink) {
          const hoverSrc = imgLink.closest(".mega-menu__collection-link").dataset.image;
          imgLink.src = hoverSrc;
        }
      });
      item.addEventListener("mouseleave", () => {
        if (imgLink && originalSrc) {
          imgLink.src = originalSrc;
        }
      });
    });
    menu.addEventListener("mouseleave", () => {
      items.forEach(i => i.classList.remove("mega-menu__column--active"));
      firstItem.classList.add("mega-menu__column--active");
    });
  });
});